import { useState } from "react";
import { addProductionSubcategory, removeProductionSubcategory } from "./ehpadRules";
import { btnOutlineStyle, inputStyle } from "../styles/adminDashboardStyles";

export function ProductionSubcategoryManager({ values, draft, onDraftChange, onValuesChange, inputId }) {
    const [hovered, setHovered] = useState(null);
    const add = () => {
        const next = addProductionSubcategory(values, draft);
        onValuesChange(next);
        if (next !== values) onDraftChange("");
    };

    return (
        <div style={{ display: "grid", gap: "8px" }}>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                <input
                    id={inputId}
                    style={{ ...inputStyle, flex: "1 1 220px" }}
                    placeholder="ABC 1"
                    value={draft}
                    onChange={e => onDraftChange(e.target.value)}
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            add();
                        }
                    }}
                />
                <button type="button" onClick={add} style={btnOutlineStyle}>
                    Ajouter
                </button>
            </div>
            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", minHeight: "26px" }}>
                {values.length === 0 ? (
                    <span style={{ color: "#9ca3af", fontSize: "12px", fontWeight: 500 }}>Aucune sous-catégorie</span>
                ) : values.map(value => (
                    <button
                        key={value}
                        type="button"
                        title={`Supprimer ${value}`}
                        onMouseEnter={() => setHovered(value)}
                        onMouseLeave={() => setHovered(current => current === value ? null : current)}
                        onClick={() => onValuesChange(removeProductionSubcategory(values, value))}
                        style={{
                            border: "1px solid #bfdbfe",
                            background: hovered === value ? "#fee2e2" : "#eff6ff",
                            color: hovered === value ? "#991b1b" : "#1d4ed8",
                            borderRadius: "7px",
                            padding: "4px 8px",
                            fontSize: "12px",
                            fontWeight: 800,
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                        }}
                    >
                        {value}
                        <span style={{ opacity: hovered === value ? 1 : 0.35 }}>×</span>
                    </button>
                ))}
            </div>
        </div>
    );
}

/**
 * Formulaire « Ajouter un EHPAD » avec son propre état : une frappe ne re-rend que le formulaire,
 * pas toute la liste des EHPADs (qui peut compter des centaines de lignes).
 */
